export default {
  mobile_app_average_order_value: {
    label: 'Panier moyen via appli',
  },
  mobile_app_gmv: {
    label: 'Ventes via appli',
  },
  mobile_app_gmv_percentage: {
    label: '% revenus via appli',
  },
  mobile_app_downloads: {
    label: 'Téléchargements',
  },
  mobile_app_orders_count: {
    label: 'Commandes via appli',
  },
  name: {
    label: 'Restaurant',
  },
  mobile_app_released_at: {
    label: 'Date de lancement',
  },
  title: 'Annuaire des restaurants',
};
